import { axios } from '@Root/API'

export const getCourseSessions = (engagementId, params) => {
	return axios.get(`engagement/${engagementId}/course-session`, { params })
}
